import React from "react";
import {
  FormGroup,
  Row,
  Col,
} from "reactstrap";

export const NegotiateAgreement = () => {
  return (
    <div
      style={{
        fontStyle: "normal",
        fontFamily: "sans-serif",
        backgroundColor: "white",
        textAlign: "justify",
        textJustify: "inter-word",
        padding: "30px 70px"
      }}
    >
      <Row>
        <Col xl={2} md={2} lg={2}>
        </Col>
        <Col xl={8} md={8} lg={8}>
          <FormGroup>
            <div>
              <p style={{ fontSize: "17px", textAlign: "center" }}><b>Negotiate an Agreement.</b></p>
              <p style={{ marginTop: "3%" }}>
                Now that you have completed Step 1 and Step
                2, you are in position to negotiate a global agreement with your
                spouse, one that includes the division of property and debts,
                spousal support; and if you have children, child custody and child
                support. Please watch your <span><a target="_blank" href="https://thecompletedivorce.thinkific.com/users/sign_in">video tutorials</a></span> on each topic in your
                Thinkific platform for guidance. You will also find instructions
                there on how to calculate support.</p>
              <p style={{ marginTop: "3%" }}> If you have trouble resolving an issue, look for mediation or settlement services that your court
                offers like a Settlement Officer Conference or Personal Property
                Arbitration, which are free public services. If you need more, you
                can check out my mediation practice,<span> <a target="_blank" href="https://ffmediation.com/">Families First Mediation </a></span>.</p>
              <p style={{ marginTop: "3%" }}>
                Once completed, you can move on to Step 4 to assemble your agreements
                into the MSA and attach it to your Judgment Packet, your end goal.
              </p>
              <p style={{ marginTop: "3%", float: "right" }}>
                <b>
                  ~ Dina
                </b>
              </p>
            </div>
          </FormGroup>
        </Col>
        <Col xl={2} md={2} lg={2}>
        </Col>
      </Row>
    </div>
  );
}